export default __webpack_public_path__ + "static/media/Icono 14.62d88913.svg";